import React, { createContext } from "react";

const DrawerContext = React.createContext();

export default DrawerContext;
